import { Component } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { BooleanInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FeatureComponent } from '@business/feature/components/features/feature.component';
import { BasicFeatureFormModel } from '@business/feature/models/basic-feature-form-model';
import { Feature, FeatureModel } from '@business/feature/models/feature-model';

export interface PhoneBook extends Feature {
  phoneBookLookupData: PhoneBookLookupData;
}

export interface PhoneBookLookupData {
  isCorporateEditAllowed: boolean;
}

@FormMapping()
export class PhoneBookFormModel extends BasicFeatureFormModel {
  @BooleanInput({
    selector: 'phoneBookLookupData.isCorporateEditAllowed',
    defaultValue: false,
  })
  isCorporateEditAllowed: boolean;
}

@Component({
  selector: 'portal-feature-phone-book',
  templateUrl: './feature-phone-book.component.html',
  styles: [],
  standalone: false,
})
export class FeaturePhoneBookComponent extends FeatureComponent {
  protected formModel = PhoneBookFormModel;
  protected updateComponent = undefined;

  Permission = SecurityPermissionName;

  ngOnInit(): void {
    super.ngOnInit();

    if (this.authenticationService.userIsEndUser()) {
      this.form.get('isCorporateEditAllowed').disable();
    }
  }

  protected getFeature() {
    return new FeatureModel(this.featuresViewModel.features.phoneBook);
  }
}
